import React, { useEffect, useState } from 'react'
import { Btn, CustomModal, InputText } from '../../../../components'
import { CONFIG } from '../../../../config'

const LIMITE_EMAILS = 10
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const EM_PRODUCAO = CONFIG.ENVIROMENT === 'PROD'

function ModalReenviarEmailNfse({ nfse, isVisible, onCancel, onSave, onError }) {
  // Hooks
  const [emails, setEmails] = useState('')

  useEffect(() => {
    if (isVisible) setEmails(nfse && nfse.tomador_email ? nfse.tomador_email : '')
  }, [isVisible, nfse])

  if (!nfse) return null

  // Events
  const onBtnEnviarClicked = () => {
    const lista = Array.from(
      new Set(
        emails
          .split(/[;,\s]+/)
          .map(email => email.trim())
          .filter(Boolean),
      ),
    )
    if (!lista.length) return onError('Informe ao menos um e-mail')
    if (lista.length > LIMITE_EMAILS) return onError(`Informe no máximo ${LIMITE_EMAILS} e-mails`)
    const invalido = lista.find(email => !EMAIL_REGEX.test(email))
    if (invalido) return onError(`E-mail inválido: ${invalido}`)
    onSave(nfse, lista)
  }

  // Render
  return (
    <CustomModal
      header={`Reenviar e-mail da NFS-e nº ${nfse.numero}`}
      isVisible={isVisible}
      onClose={onCancel}
    >
      <form className="p-grid">
        {!EM_PRODUCAO && (
          <div className="p-col-12">
            <span style={{ color: '#856404', fontSize: 12 }}>Disponível apenas em produção</span>
          </div>
        )}
        <div className="p-col-12">
          <InputText
            label={`E-mails (separados por vírgula, até ${LIMITE_EMAILS}):`}
            marginTop={10}
            value={emails}
            disabled={!EM_PRODUCAO}
            onChange={value => setEmails(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnEnviarClicked} disabled={!EM_PRODUCAO}>
            Enviar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalReenviarEmailNfse
